module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Mayans-S1.3e42b90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Mayans-S1.jpg
// module id = wKvc
// module chunks = 0